import { render, staticRenderFns } from "./CircleColor.vue?vue&type=template&id=8f6588d4&"
import script from "./CircleColor.vue?vue&type=script&lang=js&"
export * from "./CircleColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports